import {compareAsc, parseISO} from 'date-fns';
import {Pattern, match} from 'ts-pattern';

import type {BusinessCasePlannedActivity} from '@prompt-bridge/shared/ai-assistant-core';

export const compareBusinessCasePlannedActivities = (
  left: BusinessCasePlannedActivity,
  right: BusinessCasePlannedActivity
) =>
  match([left.dueAt, right.dueAt])
    .with(
      [Pattern.string, Pattern.string],
      ([leftDueAt, rightDueAt]) =>
        compareAsc(parseISO(leftDueAt), parseISO(rightDueAt)) || left.id.localeCompare(right.id)
    )
    .with([Pattern.string, Pattern.nullish], () => -1)
    .with([Pattern.nullish, Pattern.string], () => 1)
    .otherwise(() => left.id.localeCompare(right.id));
